import { render, staticRenderFns } from "./ShowCellProductsDialog.vue?vue&type=template&id=bc45279c"
import script from "./ShowCellProductsDialog.vue?vue&type=script&lang=js"
export * from "./ShowCellProductsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports